import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";

export default function GamingiGamingLicenseMalta (){

    return (
        <main className='main'>

            <IntroSection
                title="Gaming & iGaming License – Malta (MGA)"
                subtitle="The Gold Standard in Global iGaming Regulation"
                description =
                    "<b>Malta</b> is considered the <b>pioneer and world leader in online gaming regulation</b>, being the first EU country to regulate iGaming in 2004. Today, the <b>Malta Gaming Authority (MGA)</b> issues some of the <b>most prestigious and globally recognized licenses</b>, trusted by <b>regulators, investors, affiliates, and payment providers</b> worldwide."
                badges={[
                    "Online Casino",
                    "Sportsbook",
                    "Poker & Skill Games",
                    "Lottery & Fantasy Sports"
                ]}
                buttonText="Request a Malta Gaming Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/gaming-igaming-license-malta-hero-image.png")}
                imageAlt="Gaming License Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Malta for iGaming?'
                        blocks={[
                            {
                                items:
                                    [
                                        { title: "Global Prestige", text: "one of the most respected iGaming licenses worldwide" },
                                        { title: "EU-Regulated", text: "fully aligned with EU directives and FATF standards" },
                                        { title: "Passporting Rights", text: "serve the entire EEA (European Economic Area) from Malta" },
                                        { title: "PSP & Banking Friendly", text: "strong acceptance by Visa/Mastercard, banks, and EMIs" },
                                        { title: "Investor & Affiliate Confidence", text: "a Malta license attracts partners and credibility" },
                                        { title: "Player Protection", text: "high compliance standards ensure trust and security" }
                                    ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Types of MGA Gaming Licenses"
                        subtitle='Malta Gaming Authority (MGA) issues two main categories:'
                        blocks={[
                            {
                                title: "B2C – Gaming Service License",
                                subtitle: "For operators providing games directly to players. Covers:",
                                items: [
                                    { title: "Casino Games", text: "slots, table games, live dealer, RNG" },
                                    { title: "Sports Betting", text: "pre-match, live, eSports, virtual sports" },
                                    { title: "Poker & Skill Games" },
                                    { title: "Lotteries & Fantasy Sports"}
                                ]

                            },
                            {
                                title: "B2B – Gaming Supply License",
                                subtitle: "For companies providing products/services to other operators. Covers:",
                                items: [
                                    { title: "Casino Game Developers"},
                                    { title: "Sportsbook Software Providers"},
                                    { title: "White Label Solutions"},
                                    { title: "Platform Hosting & Aggregators"}
                                ]
                            },
                        ]}
                    />


                    <FeatureCards
                        title='Capital & Compliance Requirements'
                        features={
                            [
                                { title: "Minimum Capital", text: "€100,000–€240,000 (depending on license type & business model)" },
                                { title: "Application Requirements", text: "Business plan, financial projections, corporate governance, AML/KYC framework, responsible gaming policies, technical system audit (approved MGA auditor)" },
                                { title: "Local Presence", text: "At least one Key Function Holder must be based in Malta" }
                            ]
                        }
                    />

                    <LocationTimeline
                        title='Benefits of a Malta Gaming License'
                        item={
                            [
                                { title: "Global Recognition", text: "respected by regulators, investors, and affiliates" },
                                { title: "Compliance Advantage", text: "strengthens legal standing with partners" },
                                { title: "Easier Banking/PSP Onboarding", text: "compared to offshore regulators" },
                                { title: "Market Access", text: "EU-wide operations via passporting rights" },
                                { title: "High Valuation for Companies", text: "MGA-licensed companies attract higher M&A multiples" }
                            ]
                        }
                    />

                    {/* Services */}
                    <ServiceCards
                        title='Licensing Process'
                        services={
                            [
                                { title: "Pre-Application Consultation", text: "structure the gaming business model" },
                                { title: "Company Incorporation", text: "register an entity in Malta" },
                                { title: "Application Submission", text: "business plan, compliance manuals, governance documents" },
                                { title: "MGA Review", text: "assessment of financials, compliance, systems, and policies" },
                                { title: "System Audit & Testing", text: "conducted by MGA-approved auditors" },
                                { title: "License Approval & Launch", text: "usually within 6–12 months" }
                            ]
                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                description: "(longer than offshore licenses)",
                                duration: "6–12 months",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Setup Costs",
                                description: "from €35,000+",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Capital Requirement",
                                description: "€100,000–€240,000 depending on license",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Annual Renewal & Compliance Costs",
                                description: "higher than offshore regulators",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Experts in MGA licensing and EU compliance" },
                                { text: "Full service: incorporation, compliance, system audit, license application" },
                                { text: "Connections to PSPs, EMIs, banks, and affiliate networks" },
                                { text: "Comparison guidance: Malta vs Offshore jurisdictions" },
                                { text: "Support in expanding into white-label and B2B partnerships" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title='Looking for the most prestigious gaming license in the world?'
                         description=
                             "<b>The Malta Gaming Authority (MGA)</b> offers <b>Tier-1 iGaming licenses</b> with <b>global trust</b>, seamless <b>PSP access</b>, and full <b>EU market entry</b>."
                         buttonText='Book a Malta Gaming License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

export const faqData = [
    {
        question: "Is Malta the best iGaming jurisdiction?",
        answer: "Yes — MGA licenses are considered the gold standard globally."
    },
    {
        question: "How long does it take to get licensed?",
        answer: "6–12 months, depending on the complexity of the business model."
    },
    {
        question: "What is the capital requirement?",
        answer: "€100,000–€240,000 depending on the license category."
    },
    {
        question: "Can I operate both casino and sportsbook under one license?",
        answer: "Yes — MGA allows multi-vertical operations."
    },
    {
        question: "Is a local office required?",
        answer: "Yes — you need a Malta-based presence and key compliance roles."
    }
];

const testimonialsData =
    [
        {
            quote: "We licensed our sportsbook under MGA with Offshore Advisory. The process was demanding, but now we enjoy full EU credibility.",
            author: "Richard T.",
            role: "Sportsbook Operator"
        },
        {
            quote: "An MGA casino license gave us recognition with affiliates and PSPs. Offshore Advisory guided us every step.",
            author: "Sofia K.",
            role: "Casino Operator"
        }
    ]
;